/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { SalesAssignmentVO } from './sales-assignment-vo.model';

export class TerritoryVO extends JSONable {
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  salesAssignmentVOs: SalesAssignmentVO[] | undefined = undefined;

  fromJSON(json: any) {
    super.fromJSON?.(json);
    if (!this.salesAssignmentVOs) {
      this.salesAssignmentVOs = [];
    }
  }
}
